import React, { useState } from "react";
import { Container, TextField, Button, Typography } from "@mui/material";
import { ReactComponent as Logo } from '../dashboard/logo.svg'
import { useColorMode } from "../ColorModeContext";
import { blueGrey, grey} from "@mui/material/colors";


const CORRECT_PASSWORD = process.env.CORRECT_PASSWORD || "";

interface LoginProps {
  onAuthenticate: () => void;
}

const Login: React.FC<LoginProps> = ({ onAuthenticate }) => {
    const [password, setPassword] = useState("");
    const [error, setError] = useState(false);
    const {colorMode} = useColorMode();
  const handleLogin = () => {
    if (password === CORRECT_PASSWORD) {
      onAuthenticate(); 
    } else {
      setError(true);
    }
  };

  return (
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "87.5vh",
      }}
    >
        <Logo
        style={{height:'20vh', marginBottom:'40px', fill:colorMode?grey[200]:blueGrey[800]}}
        />
      <Typography variant="h5" gutterBottom>
        HPP Vizz access
      </Typography>
      <TextField
        label="Password"
        type="password"
        variant="outlined"
        fullWidth
        error={error}
        helperText={error ? "Incorrect password. Try again." : ""}
        onChange={(e) => {
          setPassword(e.target.value);
          setError(false); // Reset error when typing
        }}
        sx={{ mb: 2 }}
      />
      <Button
        variant="contained"
        fullWidth
        onClick={handleLogin}
      >
        Enter
      </Button>
    </Container>
  );
};

export default Login;
